const pages = Object.freeze({
  HOME: "/",
  SHEET: { PATH: "/sheet/:appId/:sheetId", NAME: "SHEET_TITLE" },
} as const);

export default pages;
